import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["arrow", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as r } from "react/jsx-runtime";
import { Button as a } from "../Button/Button.js";
import { c } from "../clsx-OuTLNxxd.js";
const i = "PaginationButton-module_button__aUoNE",
  s = {
    button: i
  },
  f = _ref => {
    let {
        arrow: t,
        className: o = ""
      } = _ref,
      n = _objectWithoutProperties(_ref, _excluded);
    const e = t == "left" ? "chevron-left" : "chevron-right";
    return /* @__PURE__ */r(a, _objectSpread({
      className: c(o, s.button),
      variant: "elevated",
      iconName: e
    }, n));
  };
export { f as PaginationButton };